import {Stack} from '@mui/material';
import {ContactInfo, CTAButtonFixed, StyledCard} from 'presentation/components';
import {Loading} from 'presentation/components/Loading/Loading';
import {ModalError} from 'presentation/components/ModalError';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import React, {Fragment} from 'react';
import {FormProvider} from 'react-hook-form';
import {RequestScheduleAvailabilitySelect} from '../RequestScheduleAvailabilitySelect';
import {RequestScheduleBeneficiaryData} from '../RequestScheduleBeneficiaryData';
import {RequestScheduleHeader} from '../RequestScheduleHeader';
import {RequestScheduleSucessModal} from '../RequestScheduleSucessModal';
import {TypeOfConsultation} from '../TypeOfConsultation';
import {useRequestScheduleLayout} from './hooks/useRequestScheduleLayout';

const {confirmSolicitation, errorModal} =
	translations['pt-br'].privateFlow.bookingFlow.requestSchedule;

export const RequestScheduleLayout = () => {
	const {isMobile, isDesktop} = useMediaQueries();

	const {
		handleSubmit,
		handleConfirm,
		handleCloseErrorModal,
		errorState,
		successProtocolState,
		successState,
		watchedData,
		setValue,
		methods,
		currentPhone,
		currentEmail,
		isSubmitting,
		handleGoToHome,
	} = useRequestScheduleLayout();

	return (
		<Fragment>
			<FormProvider {...methods}>
				<form onSubmit={handleSubmit(handleConfirm)}>
					<Stack gap={2}>
						<RequestScheduleHeader />
						<ContactInfo
							user={{
								cellphone: currentPhone,
								email: currentEmail,
							}}
							checked={watchedData.whatsappUpdates}
							handleCheck={(_, check) => setValue('whatsappUpdates', check)}
							showCheckbox
						/>
						<StyledCard.Container sx={{p: 1.5}}>
							<TypeOfConsultation />
							<RequestScheduleAvailabilitySelect />
						</StyledCard.Container>
						{!isDesktop ? <RequestScheduleBeneficiaryData /> : null}
						<CTAButtonFixed.Root>
							<CTAButtonFixed.Action
								fullWidth={isMobile}
								type="submit"
								sx={{alignSelf: 'flex-end'}}
								size="large"
								endIcon={
									isSubmitting ? <Loading size={12} color="inherit" /> : null
								}>
								{confirmSolicitation}
							</CTAButtonFixed.Action>
						</CTAButtonFixed.Root>
					</Stack>
				</form>
			</FormProvider>

			<RequestScheduleSucessModal open={successState} protocol={successProtocolState} />

			<ModalError
				isFullScreen={false}
				maxWidth={420}
				onClose={handleCloseErrorModal}
				headerTitle={errorModal.headerModalTitle}
				title={errorModal.headerTitle}
				description={errorModal.description}
				open={errorState}
				firstButton={{
					title: errorModal.firstButton,
					handleClick: handleCloseErrorModal,
				}}
				secondButton={{
					title: errorModal.secondButton,
					handleClick: handleGoToHome,
				}}
			/>
		</Fragment>
	);
};
